<template>
  <div
    v-if="copied"
    class="anz-post-tooltip anz-bg-orange-light anz-py-s anz-pl-l anz-pr-s anz-b-rounded anz-flex anz-align-items-center"
  >
    <h6 class="anz-fs-xs anz-align-center anz-ml-auto anz-mr-auto">
      {{ $translate('post.actionResults.copied') }}
    </h6>
    <a-button
      class-name="anz-link anz-color-beige anz-block anz-ml-s"
      @click="$emit('tooltip-close')"
      show-icon
      icon-width="0.7142em"
      icon-height="0.7142em"
      icon-name="cross-solid"
      icon-class="anz-block"
    />
  </div>
  <div
    v-else
    class="anz-post-tooltip anz-post-tooltip--share anz-bg-orange-light anz-pt-s anz-pb-xs anz-pl-l anz-pr-s anz-b-rounded anz-flex anz-align-items-start anz-align-items-center-sm"
  >
    <div class="anz-flex-sm anz-flex-fill anz-align-items-center">
      <h6 class="anz-fs-xs anz-mb-s anz-mb-xs-sm">
        {{ $translate('post.actions.share') }}
      </h6>
      <div class="anz-ml-auto anz-mr-auto anz-wf-mo">
        <div class="anz-flex anz-flex-wrap anz-justify-content-center-sm">
          <a-social-button
            :href="generateFacebookShare(post)"
            class="anz-post__share-fb anz-mr-l anz-color-black-70 anz-fs-xxxs anz-mb-xs anz-link-hover-underline"
            @click="propagateFacebookEvent"
          >
            <template #title>
              <span class="anz-hidden-sm">
                <a-icon
                  name="fb"
                  width="1.25em"
                  height="1.25em"
                  class-name="anz-mr-xs anz-color-facebook"
                />
              </span>
              <span class="anz-hidden-mo anz-flex-sm anz-align-items-center">
                <a-icon
                  name="fb"
                  width="1em"
                  height="1em"
                  class-name="anz-mr-xs anz-color-facebook"
                />
                Facebook
              </span>
            </template>
          </a-social-button>
          <a-social-button
            :href="generateMessengerShare(post)"
            class="anz-hidden-sm anz-post__share-fb-mg anz-mr-l anz-color-black-70 anz-fs-xxxs anz-mb-xs anz-link-hover-underline"
            @click="propagateMessengerEvent"
          >
            <template #title>
              <span class="anz-hidden-sm">
                <a-icon
                  name="messenger"
                  width="1.5em"
                  height="1.5em"
                  class-name="anz-mr-xs anz-color-facebook"
                />
              </span>
              <span class="anz-hidden-mo anz-flex-sm anz-align-items-center">
                <a-icon
                  name="messenger"
                  width="1.2142em"
                  height="1.2142em"
                  class-name="anz-mr-xs anz-color-facebook"
                />
                Messenger
              </span>
            </template>
          </a-social-button>
          <a-social-button
            :href="generateWhatsAppShare(post)"
            class="anz-post__share-whatsapp anz-mr-l anz-color-black-70 anz-fs-xxxs anz-mb-xs anz-link-hover-underline"
            @click="propagateWhatsAppEvent"
          >
            <template #title>
              <span class="anz-hidden-sm">
                <a-icon
                  name="whatsapp"
                  width="1.25em"
                  height="1.25em"
                  class-name="anz-mr-xs anz-color-whatsapp"
                />
              </span>
              <span class="anz-hidden-mo anz-flex-sm anz-align-items-center">
                <a-icon
                  name="whatsapp"
                  width="1em"
                  height="1em"
                  class-name="anz-mr-xs anz-color-whatsapp"
                />
                WhatsApp
              </span>
            </template>
          </a-social-button>
          <a-social-button
            :href="generateLinkedinShare(post)"
            @click="propagateLinkedInEvent"
            class="anz-post__share-linkedin anz-mr-l anz-color-black-70 anz-fs-xxxs anz-mb-xs anz-link-hover-underline"
          >
            <template #title>
              <span class="anz-hidden-sm">
                <a-icon
                  name="linkedin"
                  width="1.25em"
                  height="1.25em"
                  class-name="anz-mr-xs anz-color-linkedin"
                />
              </span>
              <span class="anz-hidden-mo anz-flex-sm anz-align-items-center">
                <a-icon
                  name="linkedin"
                  width="1em"
                  height="1em"
                  class-name="anz-mr-xs anz-color-linkedin"
                />
                LinkedIn
              </span>
            </template>
          </a-social-button>
          <a-social-button
            :href="generateViberShare(post)"
            @click="propagateViberEvent"
            class="anz-hidden-sm anz-post__share-viber anz-mr-l anz-color-black-70 anz-fs-xxxs anz-mb-xs anz-link-hover-underline"
          >
            <template #title>
              <span class="anz-hidden-sm">
                <a-icon
                  name="viber"
                  width="1.35em"
                  height="1.35em"
                  class-name="anz-mr-xs anz-color-viber"
                />
              </span>
              <span class="anz-hidden-mo anz-flex-sm anz-align-items-center">
                <a-icon
                  name="viber"
                  width="1em"
                  height="1em"
                  class-name="anz-mr-xs anz-color-viber"
                />
                Viber
              </span>
            </template>
          </a-social-button>
          <a-button
            class-name="anz-link anz-btn-icon anz-color-black-70 anz-fs-xxxs anz-mb-xs anz-link-hover-underline"
            @click="copy"
            data-cy="post-copy-link"
          >
            <template #title>
              <span class="anz-hidden-sm">
                <a-icon
                  name="copy"
                  width="1.1em"
                  height="1.1em"
                  class-name="anz-mr-xs anz-color-primary"
                />
              </span>
              <span class="anz-hidden-mo anz-flex-sm anz-align-items-center">
                <a-icon
                  name="copy"
                  width="1em"
                  height="1em"
                  class-name="anz-mr-xs anz-color-primary"
                />
                {{ $translate('post.actions.copy') }}
              </span>
            </template>
          </a-button>
        </div>
      </div>
    </div>
    <a-button
      class-name="anz-link anz-color-beige anz-block anz-ml-s anz-mb-xs"
      @click="$emit('tooltip-close')"
      show-icon
      icon-width="0.7142em"
      icon-height="0.7142em"
      icon-name="cross-solid"
      icon-class="anz-block"
    />
    <input
      class="anz-post-tooltip__share-input"
      ref="postRouteInput"
      :value="generatePostRoute(post)"
      readonly
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'
import ASocialButton from '@/components/Forms/ASocialButton.vue'
import { useRouter } from '@/routing/router'
import { TOOLTIP_COMPONENTS } from '@/composables/post/postTooltip'
import usePostShareManager, {
  usePostCopyManager,
} from '@/composables/share/postShareManager'
import { Post } from '@/model/data-object/Post'

export default defineComponent({
  name: TOOLTIP_COMPONENTS.POST_COPY,
  emits: ['tooltip-close'],
  components: {
    AButton,
    AIcon,
    ASocialButton,
  },
  props: {
    post: {
      type: Object, // todo change type to post
      default: {},
    },
    alreadyPerformed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {
      ...useRouter(),
      ...usePostShareManager(props.post as Post),
      ...usePostCopyManager(props.post as Post),
    }
  },
})
</script>
